export let apiBaseUrl: string;

switch (process.env.REACT_APP_STAGE) {
   case 'prod':
      apiBaseUrl = 'https://api.neuvanalife.com';
      break;
   case 'study':
      apiBaseUrl = 'https://api-study.neuvanalife.com';
      break;
   case 'test':
      apiBaseUrl = 'https://api-test.neuvanalife.com';
      break;
   case 'dev':
      apiBaseUrl = 'https://api-dev.neuvanalife.com';
      break;
   default:
      apiBaseUrl = 'https://api-staging.neuvanalife.com';
}
